export default ($) => {

  const section = document.getElementById('js-searchSection');
  if (!section) return;
  const searchBox = document.getElementById('js-searchBox');

  // ── 要素参照 ──────────────────────────────────────────────
  const apiUrl        = section.dataset.api;
  const mainForm      = document.getElementById('js-searchForm');
  const stickyForm    = document.getElementById('js-stickyForm');
  const results       = document.getElementById('js-searchResults');
  const articleList   = document.getElementById('js-articleList');
  const searchEmpty   = document.getElementById('js-searchEmpty');
  const searchMore    = document.getElementById('js-searchMore');
  const loadMoreBtn   = document.getElementById('js-loadMore');
  const sticky        = document.getElementById('js-searchSticky');
  const stickyToggle  = document.getElementById('js-stickyToggle');
  const stickyFormWrap = document.getElementById('js-stickyFormWrap');

  // 連打対策：新しいリクエストを投げる際に前回分を中断する
  let activeController = null;

  // 検索/もっと見るの競合対策：自分より新しいリクエストが走っていたら
  // 中断された側の finally で UI 状態（ボタンの disabled 等）を戻さない
  let latestRequestToken = 0;

  // ── ブラウザバック復元用の検索状態保存 ───────────────────
  const STATE_KEY = 'jiyukenkyu:searchState';

  function saveState(values, data) {
    try {
      sessionStorage.setItem(STATE_KEY, JSON.stringify({
        values,
        html:     articleList.innerHTML,
        total:    data.total,
        hasMore:  data.has_more,
        nextPage: data.next_page,
      }));
    } catch (e) { /* ignore (private mode 等でsessionStorageが使えない場合) */ }
  }

  function loadState() {
    try {
      const raw = sessionStorage.getItem(STATE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  // 直前がブラウザバック/フォワードによる遷移かどうか
  function isBackForwardNavigation() {
    const [entry] = performance.getEntriesByType('navigation');
    return entry ? entry.type === 'back_forward' : false;
  }

  // ── フォームの選択値を取得 ────────────────────────────────
  function getFormValues(form) {
    return {
      genre:  form.querySelector('[name="genre"]').value,
      grade:  form.querySelector('[name="grade"]').value,
      period: form.querySelector('[name="period"]').value,
    };
  }

  // ── API パラメータを構築 ──────────────────────────────────
  function buildParams(values, page) {
    const params = new URLSearchParams();
    if (values.genre)  params.append('genre[]',  values.genre);
    if (values.grade)  params.append('grade[]',  values.grade);
    if (values.period) params.append('period[]', values.period);
    params.set('page', page);
    return params;
  }

  // ── API 呼び出し ──────────────────────────────────────────
  // 実行中のリクエストがあれば中断し、常に最新の1件だけが結果に反映されるようにする
  async function fetchArticles(values, page) {
    activeController?.abort();
    const controller = new AbortController();
    activeController = controller;
    const res = await fetch(`${apiUrl}?${buildParams(values, page).toString()}`, {
      signal: controller.signal,
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  }

  // ── 結果エリアを更新 ──────────────────────────────────────
  function applyResults(data, append) {
    results.dataset.total    = data.total;
    results.dataset.hasMore  = data.has_more ? 'true' : 'false';
    results.dataset.nextPage = data.next_page != null ? String(data.next_page) : '';

    if (data.total === 0) {
      articleList.innerHTML = '';
      searchEmpty.hidden    = false;
      searchMore.hidden     = true;
    } else {
      if (append) {
        articleList.insertAdjacentHTML('beforeend', data.html);
      } else {
        articleList.innerHTML = data.html;
      }
      searchEmpty.hidden = true;
      searchMore.hidden  = !data.has_more;
    }
  }

  // ── 両フォームの値を同期 ──────────────────────────────────
  function syncForms(sourceForm, values) {
    const target = sourceForm === mainForm ? stickyForm : mainForm;
    setFormValues(target, values);
  }

  function setFormValues(form, values) {
    form.querySelector('[name="genre"]').value  = values.genre;
    form.querySelector('[name="grade"]').value  = values.grade;
    form.querySelector('[name="period"]').value = values.period;
  }

  // ── 検索フォーム送信 ──────────────────────────────────────
  async function handleSearch(e) {
    e.preventDefault();
    const values = getFormValues(e.target);
    syncForms(e.target, values);
    // どちらのフォームから送信されても、両フォームの送信ボタンをまとめて
    // disable/enableする（片方だけ操作するとフォーム間の競合時に
    // 押されなかった側のボタンが disabled のまま取り残されるため）
    const submitButtons = [mainForm, stickyForm]
      .map((form) => form.querySelector('button[type="submit"]'))
      .filter(Boolean);
    const token = ++latestRequestToken;
    // loadMoreBtn.disabled とtokenガードで競合を防いでいるため、
    // searchMore の表示状態はここでは変更しない（失敗時に旧結果の
    // 「もっと見る」が消えたまま戻らなくなるのを避ける）
    loadMoreBtn.disabled = true;
    submitButtons.forEach((btn) => { btn.disabled = true; });
    try {
      const data = await fetchArticles(values, 1);
      if (token !== latestRequestToken) return; // 後続のリクエストに追い越された
      applyResults(data, false);
      saveState(values, data);
      // 結果エリア先頭にスムーズスクロール
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      if (err.name === 'AbortError') return; // 後続リクエストに中断された分は無視
      console.error('[jiyukenkyu] search error:', err);
    } finally {
      // 自分より新しいリクエストが走っていればUI状態はそちらに委ねる
      if (token === latestRequestToken) {
        loadMoreBtn.disabled = false;
        submitButtons.forEach((btn) => { btn.disabled = false; });
      }
    }
  }

  // ── もっと見る ────────────────────────────────────────────
  async function handleLoadMore() {
    const nextPage = parseInt(results.dataset.nextPage, 10);
    if (!nextPage) return;
    const values = getFormValues(mainForm);
    const token = ++latestRequestToken;
    loadMoreBtn.disabled = true;
    try {
      const data = await fetchArticles(values, nextPage);
      if (token !== latestRequestToken) return; // 後続のリクエストに追い越された
      applyResults(data, true);
      saveState(values, data);
    } catch (err) {
      if (err.name === 'AbortError') return; // 後続リクエストに中断された分は無視
      console.error('[jiyukenkyu] load more error:', err);
    } finally {
      // 自分より新しいリクエストが走っていればUI状態はそちらに委ねる
      if (token === latestRequestToken) {
        loadMoreBtn.disabled = false;
      }
    }
  }

  // ── スティッキーバー表示制御（IntersectionObserver）────────
  // searchBox（テーマを探す検索ボックス）が画面上方へスクロールアウトしたら表示
  if (searchBox) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const showSticky = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', showSticky);
          sticky.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
          // transformで画面外に動かしているだけなので、非表示中は
          // inertでキーボードフォーカス・操作を無効化する
          sticky.toggleAttribute('inert', !showSticky);
        });
      },
      { threshold: 0 }
    );
    observer.observe(searchBox);
  }

  // ── スティッキー開閉トグル ─────────────────────────────────
  if (stickyToggle) {
    stickyToggle.addEventListener('click', () => {
      const opening = sticky.dataset.open !== 'true';
      sticky.dataset.open = opening ? 'true' : 'false';
      stickyToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      // max-height/opacityで畳んでいるだけなので、閉じている間は
      // フォーム内のselect・buttonをinertでフォーカス不可にする
      if (stickyFormWrap) stickyFormWrap.toggleAttribute('inert', !opening);
    });
  }

  // ── セレクト変更時に両フォーム同期 ───────────────────────
  [mainForm, stickyForm].forEach((form) => {
    form.querySelectorAll('select').forEach((sel) => {
      sel.addEventListener('change', () => syncForms(form, getFormValues(form)));
    });
  });

  // ── イベントバインド ──────────────────────────────────────
  mainForm.addEventListener('submit', handleSearch);
  stickyForm.addEventListener('submit', handleSearch);
  loadMoreBtn.addEventListener('click', handleLoadMore);

  // ── 初期表示 / ブラウザバック復元 ─────────────────────────
  const savedState = isBackForwardNavigation() ? loadState() : null;

  if (savedState) {
    // ブラウザバック/フォワード時は直前の検索条件と結果（もっと見るで
    // 読み込んだ分も含む）をそのまま復元する
    setFormValues(mainForm, savedState.values);
    setFormValues(stickyForm, savedState.values);
    applyResults(
      {
        total:     savedState.total,
        has_more:  savedState.hasMore,
        next_page: savedState.nextPage,
        html:      savedState.html,
      },
      false
    );
  } else {
    // ── 初期リフレッシュ（ページキャッシュ対策）──────────────
    // PHPレンダリング済みカードを表示しつつ、APIの短いTTLで差し替える。
    // 失敗時はPHPカードをそのまま維持。
    fetchArticles({ genre: '', grade: '', period: '' }, 1)
      .then((data) => {
        applyResults(data, false);
        mainForm.reset();
        stickyForm.reset();
      })
      .catch(() => {});
  }
};
